/**
 * FursSettings API - Auto-generated typed wrapper.
 * DO NOT EDIT - Regenerate with: bun run generate
 * @generated
 */

import { getFursSettings, updateFursSettings } from "../generated/furs-settings/furs-settings";

import { wrapMethod } from "./utils";

export const fursSettings = {
  /** @see getFursSettings */
  list: wrapMethod(getFursSettings),

  /** @see updateFursSettings */
  update: wrapMethod(updateFursSettings),
} as const;

export type FursSettingsApi = typeof fursSettings;
